import axios from "axios";
import { useState } from "react";
import { toast } from "react-hot-toast";

export const useS3Upload = () => {
  const [image, setImage] = useState({});

  const handleUpload = async (key, file, fileDestination, toastIs) => {
    if (!file) {
      return;
    }
    const formData = new FormData();
    formData.append("file", file);
    console.log("file in s3", file);
    formData.append("fileDestination", fileDestination);
    try {
      const response = await axios({
        method: "post",
        url: "s3/upload",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.status === 200) {
        if (toastIs !== false) {
          toast.success(response.data?.message || "Image upload successfully");
        }
        setImage({
          ...image,
          [key]: response.data || "",
        });

        return response.data || "";
      } else {
        toast.error("Failed to upload image");
      }
    } catch (exception) {
      console.error(exception);
      toast.error("Failed to upload image");
    }
  };

  return [image, handleUpload];
};
